export const LOGIN = 'auth/login'
export const LOGOUT = 'auth/logout'
export const GET_CURRENT_USER = 'auth/get_current_user'
export const FORGOT_PASSWORD = 'auth/forgot_password'
export const RECOVERY_PASSWORD = 'auth/recovery_password'
